import {EuiTable,EuiTableHeader,EuiTableBody,EuiTableHeaderCell,EuiTableRow, EuiTableRowCell,EuiLink,EuiEmptyPrompt, EuiFlexGroup, EuiFlexGrid, EuiFlexItem} from '@elastic/eui';
import { useEffect, useMemo, useState } from 'react';
import { COLUMNSREPORT,SUBTITLESREPORT } from './columns';
import './styles.css';

export const TablaInforme = (props) =>{
    const {data, isLoading, tipo, año, moneda, idVersion, viewColumns, showMarkWater} = props;

    const [tableIsRender, setTableIsRender] = useState(false);

    useEffect(()=>{
      if(isLoading===true) setTableIsRender(false)
    },[isLoading])

    useEffect(()=>{
      if(viewColumns!==undefined) setTableIsRender(false)
    },[viewColumns])

  var targetArea = document.getElementById('AreaImprimirPDF');
  var targetTable = document.getElementById('Tabla-Informe');

  var observerTable = new MutationObserver(function(mutations) {
    const changeColumns = mutations.length>0
    if(changeColumns)
    {
      setTableIsRender(true)
    }
  });

  useEffect(()=>{
    const configTable = { childList:true, subtree: true};
    targetTable!==null && observerTable.observe(targetTable, configTable);
  },[targetTable])

  var observerAreaImprimir = new MutationObserver(function(mutations) {
    const tableElement = mutations.filter((m)=> m.addedNodes[0] && m.addedNodes[0].id === 'Tabla-Informe');
    if(tableElement.length>0)
    {
     //La tabla está en el DOM
      setTableIsRender(true)
    }
  });

  const configArea = { childList: true};
  if(targetArea!==null){observerAreaImprimir.observe(targetArea, configArea)};

  useEffect(()=> {if(tableIsRender===true)observerAreaImprimir.disconnect();},[tableIsRender])

    const getData = (level) => data.filter((f)=> f.nivel<=level && f.noMostrar === false)
   
    const getColumnsTable = useMemo(() =>{
      switch (tipo) {
        case 'TENDVEH':
        case 'PROPOBJVEH':
          return COLUMNSREPORT(año, idVersion).TENDVEH
        case 'TENDOBJ':
          return COLUMNSREPORT(año, idVersion).TENDOBJ
        case 'OBJREAL':
          return COLUMNSREPORT(año, idVersion).OBJREAL
        case 'PROOBJTEND':
          return COLUMNSREPORT(año, idVersion).PROOBJTEND
        case 'REALOBJ':
          return COLUMNSREPORT(año, idVersion).REALOBJ
        default: return []
      }
    },[tipo,año, idVersion])

    const getSubTitlesTable = useMemo(() =>{
      switch (tipo) {
        case 'TENDVEH':
        case 'PROPOBJVEH':
          return SUBTITLESREPORT(año, idVersion).TENDVEH
        case 'OBJREAL':
          return SUBTITLESREPORT(año, idVersion).OBJREAL
        case 'TENDOBJ':
          return SUBTITLESREPORT(año, idVersion).TENDOBJ
        case 'PROOBJTEND':
          return SUBTITLESREPORT(año, idVersion).PROOBJTEND
          case 'REALOBJ':
            return SUBTITLESREPORT(año, idVersion).REALOBJ
        default: return []
      }
    },[tipo,año, idVersion])



    const renderSubTitlesHeader = () =>{
      const titlesHeaders = [];
      let widthHeaderTotal=0;
     
      let filterArray = viewColumns!== undefined ? getSubTitlesTable.filter((f)=> viewColumns.includes(f.tipo) || f.tipo===undefined) : getSubTitlesTable;

      filterArray.forEach((t)=>{
        let withHeader = 0;

        for (let index = t.colIni; index <=t.colFin; index++) {
          withHeader+=parseInt(getColumnsTable[index] ? getColumnsTable[index].width : 0) 
        }

        widthHeaderTotal+=withHeader;
        
        titlesHeaders.push(
          <div
          className={'headerTitleTable'}
          style={{width:`${withHeader}px`}}
            ><span>{t.label}</span>
          </div>
        );
      })

      return <div id={'titles-table'} style={{width:`${(viewColumns === undefined ? widthHeaderTotal+'px' : (viewColumns.length>0) ? widthHeaderTotal+'px' : '100%')}`}}>{titlesHeaders}</div>
    }

    const renderHeaderCells = () =>{
        const headers = [];

        let filterArray = viewColumns!==undefined ? getColumnsTable.filter((f)=> viewColumns.includes(f.tipo) || f.tipo===undefined) : getColumnsTable;

        filterArray && filterArray.forEach((column, columnIndex) => {
            headers.push(
              <EuiTableHeaderCell
                key={column.field ? `${column.field}_headerCell` : `${columnIndex}_headerCell`}
                style={{whiteSpace: 'break-spaces', zIndex:222}}
                align={'center'}
                width={column.width}
                data-test-subj={column['data-test-subj']}
                >{column['data-test-subj']!=='centro'?column.name:''}
              </EuiTableHeaderCell>
            );
          }
        );
        return headers.length ? headers : null;
    }

    const renderRows=()=> {
      const dataRows = getData(3);
      
      let filterArray = viewColumns!==undefined ? getColumnsTable.filter((f)=> viewColumns.includes(f.tipo) || f.tipo===undefined) : getColumnsTable;

      const renderRow = (item,i) => {
          const cells = filterArray.map((column, index) => {
              const cell = null
              let child;

              if(item===undefined){
                child = column['data-test-subj'] && column['data-test-subj'].includes('centro') ? <span>{`Miles de ${moneda}`}</span>: cell
              }else{
                if (column.render) {
                  child = column.render(item);
                } else if (column.cellProvider) {
                  child = column.cellProvider(cell);
                } else if (cell.isLink) {
                  child = <EuiLink href="">{cell.value}</EuiLink>;
                } else if (cell.truncateText) {
                  child = cell.value;
                } else {
                  child = cell;
                }
              }
              
              const customClassCell = item ? (((item[column.field] && item[column.field]) < 0) 
              || (column['data-test-subj'] === 'IPCell' && item[column.field] <=0.80) ? 'negative' : '') : 'emptyCell'

              return (
                <EuiTableRowCell
                  key={column.field ? `${column.field}_rowCell` : `${index}_rowCell`}
                  className={`${column.className?column.className:''} ${customClassCell}`}
                  align={column.dataType === 'number' ? 'right' : 'left'}
                  data-test-subj={column['data-test-subj']}
                  truncateText={false}
                  textOnly={false}>
                  {child}
                </EuiTableRowCell>
              );
          });

          const customClassNacInt = item ? (item.idPais !== '@@' ? (item.idPais!=='A@' ? 'nacInt': 'cc') : `customRowLevel${item.nivel + (item.nivel == 1 && item.centroSubido ? '1'  : '') + (item.otroFormato ? ' OtroFormato' : '')}`) : 'emptyRow'
          const key = item ? (item.field ? `${item.field}_row` : `${i}_row`) : `initial_row`
          return (
            <EuiTableRow
              key={key}
              className={customClassNacInt}
              isSelected={false}
              isSelectable={true}
              hasActions={true}>
              {cells}
            </EuiTableRow>
          );
        }

        let rows = [renderRow()]

        dataRows.map((item,i) => {
          rows.push(renderRow(item,i));
        });

        return rows;
    }

    const getNotData = () => {
      return <EuiEmptyPrompt
        iconType="inspect"
        title={<h2>{`No se han obtenido datos`}</h2>}
      />
    }

    const duplicateMarkWater = (num) =>{
      let result = []
      for(let index = 0; index < num; index++) {
        result.push(<EuiFlexItem><h1 className='maskWaterText'>{`BORRADOR`}</h1></EuiFlexItem>)
      }
      return result;
    }

    const renderMarkWater = useMemo(() =>{
      const viewMarkwater = showMarkWater===true ? true : false;
     
      if(viewMarkwater===true && tableIsRender===true){
        
        var objTable = document.getElementById('Tabla-Informe');
      
        if(objTable!==undefined && objTable!==null)
        {
          const divProps =  objTable.getBoundingClientRect();

          let nColumnas = Math.floor(divProps.width/850)
          let nFilas = Math.floor(divProps.height/250)

          nColumnas = nColumnas>4?4:nColumnas
          return(
            <EuiFlexGrid columns={nColumnas} id='maskWater' style={{width:divProps.width}}>
              {duplicateMarkWater(nColumnas*nFilas)}
            </EuiFlexGrid>
          )
        }else{return null}
      }else{return null}
    },[showMarkWater,tableIsRender])

    return(
      
      <span id='AreaImprimirPDF'>
        {data && data.length>0 ?
        <>
          {renderSubTitlesHeader()}
          <EuiTable id='Tabla-Informe' responsive title='TITULO TABLA'>
            <EuiTableHeader>{renderHeaderCells()}</EuiTableHeader>
            <EuiTableBody>{renderRows()}</EuiTableBody>
          </EuiTable>
          {renderMarkWater}
        </>
        :getNotData()}
      </span>
    )
    
    // return(
    //   data && data.length>0 ?
    //   <>
    //   <span id='AreaImprimirPDF'>
    //     {renderSubTitlesHeader()}
    //     <EuiTable id='Tabla-Informe' responsive title='TITULO TABLA'>
    //       <EuiTableHeader>{renderHeaderCells()}</EuiTableHeader>
    //       <EuiTableBody>{renderRows()}</EuiTableBody>
    //     </EuiTable>
    //     {renderMarkWater}
    //     </span>
    //   </>
    //   :getNotData()
    // )
}